export class PreOrder {
    orderName?: string;
    account?: any;
    orderTemplate?: any;
    quotation?: any;
    contract?: any;
    constructor(
        account?: any,
        orderTemplate?: any,
        quotation?: any,
        contract?: any,
        orderName?: string
    ) { }
}
